import { firestore } from '@src/api/Firebase/Firebase';
import { collection } from 'firebase/firestore';

export interface RewardGoal {
    status: boolean;
    goalPoints: number;
    rewardPoints: number;
}
export interface Reward {
    id?: string;
    points: {
        name: string;
        cost: number;
        rewardPoints: number;
    };
    reward: {
        costPoints: number;
        value: number;
    };
    newUser: {
        status: boolean;
        points: number;
    };
    goals: RewardGoal[];
}
export const REWARD_COLLECTION = 'reward';
export const rewardRef = collection(firestore, REWARD_COLLECTION);
